import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import EfSection from '@elem/ui/ef-section';
import SectionLRA from '../SectionLRA';
import SectionLRB from '../SectionLRB';
import SectionLRC from '../SectionLRC';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { pageType } = useProductStore();
    const { t } = useLang('theProduct.SectionC');

    return (
        <div className={`${styles.TheComp} ${pageType === PAGE_TYPE.BASE ? 'p-b-200' : ''}`}>
            <EfSection label={t('label')} title={t('title')} desc={t('desc')} />
            <div className="SectionLRList-in">
                <div className="SectionLRList-item">
                    <SectionLRA />
                </div>
                <div className="SectionLRList-item">
                    <SectionLRB />
                </div>
                <div className="SectionLRList-item">
                    <SectionLRC />
                </div>
            </div>
        </div>
    );
}
